"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientTransport = void 0;
const axios_1 = require("axios");
const transport_1 = require("../transport");
const entanglementProtocol_1 = require("../protocol/entanglementProtocol");
class HttpClientTransport extends transport_1.AClientTransport {
    constructor(url) {
        super();
        this.pendingRequests = new Map();
        this.client = axios_1.default.create({
            baseURL: url,
            auth: {
                username: 'test',
                password: '123abc'
            },
        });
        this.protocol = new entanglementProtocol_1.EntanglementProtocol();
    }
    connect(timeout) {
        return Promise.resolve();
    }
    close() {
        return Promise.resolve();
    }
    async send(message) {
        const data = this.protocol.write(writer => altWriteTransportMessage(writer, message));
        if (data)
            await this.client.post('axon/send', data.toString('base64'));
        else
            await this.client.post('axon/send');
    }
    async sendTagged(messageId, message) {
        const data = this.protocol.write(writer => altWriteTransportMessage(writer, message));
        const pendingRequests = this.pendingRequests.get(messageId) || [];
        if (data) {
            this.pendingRequests.set(messageId, pendingRequests.concat(this.client.post(`axon/req?tag=${messageId}`, data.toString('base64'), {
                headers: {
                    'Content-Type': 'text/plain'
                }
            })));
        }
        else {
            this.pendingRequests.set(messageId, pendingRequests.concat(this.client.post(`axon/req?tag=${messageId}`)));
        }
    }
    async receive() {
        const response = await this.client.get('axon/receive');
        const message = this.protocol.read(Buffer.from(response.data.toString('utf8'), 'base64'), reader => altReadTransportMessage(reader));
        return message;
    }
    async receiveTagged(messageId) {
        const pendingRequests = this.pendingRequests.get(messageId) || [];
        const response = await (async () => {
            let pendingRequest = pendingRequests.pop();
            while (pendingRequest === null) {
                await delay(50);
                pendingRequest = pendingRequests.pop();
            }
            if (!pendingRequest)
                throw new Error();
            return pendingRequest;
        })();
        const message = this.protocol.read(Buffer.from(response.data.toString('utf8'), 'base64'), reader => altReadTransportMessage(reader));
        return message;
    }
    receiveBufferedTagged() {
        throw new Error("Method not implemented.");
    }
    sendAndReceive(message) {
        throw new Error("Method not implemented.");
    }
}
exports.HttpClientTransport = HttpClientTransport;
function altWriteTransportMessage(writer, message) {
    writer.writeIntegerValue(0);
    writer.writeIntegerValue(message.metadata.frames.length);
    for (const frame of message.metadata.frames) {
        writer.writeStringValue(frame.id);
        writer.writeData(frame.data);
    }
    writer.writeData(message.payload);
}
function altReadTransportMessage(reader) {
    const metadata = new transport_1.VolatileTransportMetadata();
    const signal = reader.readIntegerValue();
    if (signal !== 0)
        throw new Error(`Message received with signal code ${signal}`);
    const frameCount = reader.readIntegerValue();
    for (var a = 0; a < frameCount; a++) {
        const id = reader.readStringValue();
        const data = reader.readData();
        metadata.frames.push(new transport_1.VolatileTransportMetadataFrame(id, data));
    }
    const payloadData = reader.readData();
    return new transport_1.TransportMessage(payloadData, metadata);
}
function writeTransportMessage(writer, message) {
    writeInt(writer, 0);
    writeInt(writer, message.metadata.frames.length);
    for (const frame of message.metadata.frames) {
        writeString(writer, frame.id);
        writeInt(writer, frame.data.length);
        writer.write(frame.data);
    }
    writeInt(writer, message.payload.length);
    writer.write(message.payload);
}
function writeInt(writer, value) {
    const codeBuffer = Buffer.alloc(4);
    codeBuffer.writeInt32LE(value, 0);
    writer.write(codeBuffer);
}
function writeString(writer, value) {
    const encodedValue = Buffer.from(value, 'utf8');
    writeInt(writer, encodedValue.length);
    writer.write(encodedValue);
}
function readTransportMessage(reader) {
    const metadata = new transport_1.VolatileTransportMetadata();
    const signal = readInt(reader);
    if (signal !== 0)
        throw new Error(`Message received with signal code ${signal}`);
    const frameCount = readInt(reader);
    for (var a = 0; a < frameCount; a++) {
        const id = readString(reader);
        const dataLength = readInt(reader);
        const data = readBuffer(reader, dataLength);
        metadata.frames.push(new transport_1.VolatileTransportMetadataFrame(id, data));
    }
    const payloadLength = readInt(reader);
    const payloadData = readBuffer(reader, payloadLength);
    return new transport_1.TransportMessage(payloadData, metadata);
}
function readInt(reader) {
    const buffer = readBuffer(reader, 4);
    return buffer.readInt32LE(0);
}
function readString(reader) {
    const length = readInt(reader);
    const buffer = readBuffer(reader, length);
    return buffer.toString('utf8');
}
function readBuffer(reader, size) {
    const buffer = reader.read(size);
    return buffer;
}
function delay(duration) {
    return new Promise((resolve) => setTimeout(() => resolve(), duration));
}
